<template>
  <div id="keysNewsApprove">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'keysNewsApprove'
}
</script>



// WEBPACK FOOTER //
// src/views/portal/keysnews/approve/KeysNewsApprove.vue